@let apiResponse = data();
@if (apiResponse) {
  <div class="flex flex-col h-full">
    <div class="ml-2 mt-2 mb-4 text-xl">
      <b>Samlet opkrævning:</b> {{ apiResponse.sum | number: '1.2' }}
    </div>
    <div class="flex-1 overflow-hidden">
      <p-table
        [value]="apiResponse.data"
        [loading]="opkraevningUdestaaendeService.datasource.isLoading()"
        [showGridlines]="true"
        [scrollable]="true"
        scrollHeight="flex"
        stripedRows
        class="p-datatable-sm lp-table"
        selectionMode="single"
        [metaKeySelection]="true"
        (onRowSelect)="onRowSelect($event)"
        dataKey="id"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="onLazyLoad($event)"
        sortField="raadgiver.fornavn"
        [sortOrder]="1"
        [paginator]="true"
        [rows]="100"
        [totalRecords]="apiResponse.totalRowCount"
        [showJumpToPageDropdown]="true"
        letKeepScrollPosition>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="hovedRegNr">
              Regnr
              <p-sortIcon field="hovedRegNr" />
            </th>
            <th pSortableColumn="letsikringNr">
              Aftalenr
              <p-sortIcon field="letsikringNr" />
            </th>
            <th
              pSortableColumn="risikoOpkraevning.letsikringRevision.ikrafttraedelse">
              Ikrafttrædelse
              <p-sortIcon
                field="risikoOpkraevning.letsikringRevision.ikrafttraedelse" />
            </th>
            <th pSortableColumn="clearingsResultatType">
              Type
              <p-sortIcon field="clearingsResultatType" />
            </th>
            <th pSortableColumn="periodeFra">
              Periode
              <p-sortIcon field="periodeFra" />
            </th>
            <th pSortableColumn="opkraevningReference">
              Reference
              <p-sortIcon field="opkraevningReference" />
            </th>
            <th pSortableColumn="opkraevningsBeloeb">
              Beløb
              <p-sortIcon field="opkraevningsBeloeb" />
            </th>
            <th pSortableColumn="behandlet">
              Behandlet
              <p-sortIcon field="behandlet" />
            </th>
          </tr>
        </ng-template>
        <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
          <tr [pSelectableRow]="item" class="cursor-pointer">
            <td>{{ item.hovedRegNr }}</td>
            <td>{{ item.letsikringNr }}</td>
            <td>{{ item.ikrafttraedelse | date: 'dd-MM-yyyy' }}</td>
            <td>{{ item.clearingsResultatType }}</td>
            <td>
              {{ item.periodeFra | date: 'dd-MM-yyyy' }} -
              {{ item.periodeTil | date: 'dd-MM-yyyy' }}
            </td>
            <td>{{ item.opkraevningReference }}</td>
            <td class="numbers !text-right">
              {{ item.opkraevningsBeloeb | number: '1.2' }}
            </td>
            <td>{{ item.behandlet | date: 'dd-MM-yyyy' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
